import { ConnectedPosition } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, ElementRef, OnInit, signal, WritableSignal } from '@angular/core';
import { PopupRef, PopupService } from '@local/ui-infra';
import { take } from 'rxjs';
import { AnswerSearchService } from 'src/app/bar/services/answers-search.service';
import { ResourcePanelPopupComponent, ResourcePanelPopupData } from '../resource-panel-popup/resource-panel-popup.component';

@Component({
  selector: 'inline-reference-item',
  templateUrl: './inline-reference-item.component.html',
  styleUrls: ['./inline-reference-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineReferenceItemComponent implements OnInit {
  private id: string;
  private sourceType: 'chat-answer' | 'result-answer';
  private idIndex: number;
  private answerId: string;
  private searchId: string;
  private resourcePopupRef: PopupRef<ResourcePanelPopupComponent, { resourceId: string; answerType: string }>;
  iconClass: WritableSignal<string> = signal(null);

  constructor(
    private popupService: PopupService,
    private elementRef: ElementRef,
    private answerSearchService: AnswerSearchService
  ) {}

  ngOnInit() {
    const dataAttr = this.elementRef.nativeElement.getAttribute('data-attr');
    if (dataAttr) {
      const data = JSON.parse(dataAttr);
      this.id = data.id;
      this.sourceType = data.sourceType;
      this.idIndex = data.idIndex;
      this.answerId = data.answerId;
      this.searchId = data.searchId;
      this.iconClass.set(`icon-number-${data.idIndex}`);
    }
  }

  handleMouseOver($event: PointerEvent) {
    if (!this.id) {
      return;
    }
    this.openResourcePopup(
      $event,
      this.elementRef.nativeElement,
      this.id,
      this.sourceType.toString(),
      this.idIndex,
      this.answerId,
      this.searchId
    );
  }
  private openResourcePopup(
    $event: PointerEvent,
    target: HTMLElement,
    id: string,
    answerType: string,
    index: number,
    answerId: string,
    searchId: string
  ) {
    if (this.resourcePopupRef) {
      this.resourcePopupRef.destroy();
    }
    const rect = target.getBoundingClientRect();
    const openAt: { x: number; y: number } = { x: rect.left - 30, y: rect.top + 24 };
    const position: ConnectedPosition[] = [{ originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'top' }];
    this.resourcePopupRef = this.popupService.open<ResourcePanelPopupComponent, ResourcePanelPopupData>(
      openAt,
      ResourcePanelPopupComponent,
      { resourceId: id, answerType, position: $event, searchId: searchId },
      {
        position,
      }
    );
    this.answerSearchService.resourcePopupOpen$.next({ index, id: answerId });
    target.classList.add('active-reference');

    this.resourcePopupRef.destroy$.pipe(take(1)).subscribe(() => {
      this.resourcePopupRef = null;
      this.answerSearchService.resourcePopupOpen$.next({ index: null, id: answerId });
      target.classList.remove('active-reference');
    });
  }
}
